import React from 'react';
import { useMediaQuery } from 'react-responsive';
import AgenticCommerceContent from './AgenticCommerceContent';

const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  return isMobile ? children : null;
};

const MobileResponsive = ({ history }) => (
  <Mobile>
    <AgenticCommerceContent history={history} />
  </Mobile>
);

export default MobileResponsive;
